import PropTypes from 'prop-types';
import { Button, Label } from 'ypf-pas-general-ui-components';
import { LuFileSpreadsheet } from 'react-icons/lu';

import './DailyTotal.scss';

const DailyTotal = ({ title, daily, total, isPending, onClickSummaryButton }) => (
  <div className="approval-pending ">
    <div className="label-pending">
      <Label icon="" label={title} size="md" sizeValue="md" value="" />
    </div>
    <div className="container-daily-total">
      <div className="container-result">
        <div className="daily">Diarios</div>
        <div>
          <div className="daily-result">{daily}</div>
        </div>
      </div>
      {isPending ? (
        <div className="container-result">
          <div className="total">Totales</div>
          <div className="box-number">
            <div className="total-number">{total}</div>
            <Button
              className="copy-icon"
              icon={LuFileSpreadsheet}
              onClick={() => onClickSummaryButton(true)}
              sizeIcon="22px"
              variant="primary"
              widthButton="43px"
            />
          </div>
        </div>
      ) : null}
    </div>
  </div>
);

export default DailyTotal;

DailyTotal.propTypes = {
  title: PropTypes.string.isRequired,
  daily: PropTypes.number.isRequired,
  total: PropTypes.number,
  isPending: PropTypes.bool,
  onClickSummaryButton: PropTypes.func
};

DailyTotal.defaultProps = {
  isPending: false,
  total: 0,
  onClickSummaryButton: () => {}
};
